import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { convertToPersianNumber } from 'utils';
import { Close } from '@mui/icons-material'
import { Box } from '@mui/system'
import { Button, Container, Divider, IconButton, Modal, TextField, Typography,Grid } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import depositImg from 'assets/images/depositAccount/dep.svg'
import { useNavigate } from 'react-router-dom'

export const DepositPayPopUp = ({ open, value, handleClose, callbackFunction , isLoading}) => {

    console.log(value);
    // const [value, setValue] = useState(null)

    const navigate = useNavigate()


    return createPortal(<Modal
        sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
        }}
        open={open}
        onClose={() => handleClose(false)}>
        <Box sx={{
            alignItems: 'center',
            background: '#fff',
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            width: { xs: '80%', lg: '400px' },
            // px: 5,
            pb: 2.5
        }}>
            <Box sx={{
                alignItems: 'center',
                boxSizing: 'border-box',
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                position: 'relative',
                p: 1,
                width: '100%',
            }}>
                <IconButton onClick={() => handleClose(false)}><Close /></IconButton>
                <Typography fontSize={15} fontWeight='bold'>پرداخت پول</Typography>
                <IconButton sx={{ opacity: 0 }} onClick={() => handleClose(false)}><Close /></IconButton>
            </Box>

            <Divider flexItem sx={{ mt: 0, mb: 1 }} />

            <Container maxWidth='md' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                <img src={depositImg} width='150px' height='115px' />

                <Typography fontSize={15} fontWeight='600' gutterBottom>آیا مطمئن هستید مبلغ ذکر شده از کیف پول شما کسر شود؟</Typography>

                <Typography sx={{color:'#57C6C5' , fontSize:22,fontWeight:600}}>{convertToPersianNumber(value).toLocaleString('en-US') + " تومان"}</Typography>

                <Grid container spacing={1} mt={0} mb={2}>          
                    <Grid item xs={6} lg={6}>
                        <Button
                            color='primary'
                            variant='outlined'
                            fullWidth
                            onClick={() => handleClose(false)}
                            sx={{ mt: 2 }}>
                            <Typography sx={{color:'#57C6C5'}}>انصراف</Typography>
                        </Button>
                    </Grid>

                    <Grid item xs={6} lg={6}>
                        <LoadingButton
                            color='primary'
                            variant='contained'
                            fullWidth
                            onClick={() => callbackFunction(value)}
                            sx={{ mt: 2 }}
                            loading={isLoading} >
                                <Typography>پرداخت</Typography>
                        </LoadingButton>
                    </Grid>
                </Grid>

            </Container>
        </Box>

    </Modal>, document.body)
}
